export const replaceTextTemplate = (textTemplate: string, replacements: object) => {
  return textTemplate.replace(
    /{(\w+)}/g,
    (placeholderWithDelimiters: string, placeholderWithoutDelimiters: string) =>
      replacements[placeholderWithoutDelimiters as keyof object] || placeholderWithDelimiters
  );
};
